import { useCallback, useState } from 'react';
import {
  Comment,
  WebSocketConversationCommentContextType,
  WebsocketConversationMetaData,
} from 'api/conversations';
import { ProjectId } from 'api/models';
import { Action, EventType, ObjectType, SocketData } from 'api/pushes';
import { useProjectWSUpdates } from 'hooks/use-project-ws-updates';

export const useProjectConversationSocketEvents = ([, projectId]: ProjectId):
  | (Comment & WebsocketConversationMetaData)
  | undefined => {
  const [convSocketData, setSocketData] =
    useState<Comment & WebsocketConversationMetaData>();

  const handleSocketUpdates = useCallback(
    (socketData: SocketData<Comment & WebsocketConversationMetaData>) => {
      const { data } = socketData;

      if (
        data.commentContext.type ===
          WebSocketConversationCommentContextType.ProjectConversation &&
        socketData.projectId === projectId
      ) {
        setSocketData(data);
      }
    },
    [projectId],
  );

  useProjectWSUpdates(
    projectId,
    handleSocketUpdates,
    EventType(Action.Create, ObjectType.ConversationComment),
  );

  return convSocketData;
};
